import React, { useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";
import { _PageWrapper } from "../../inar2/layout";
import { _ButtonAPI } from "../../inar2/components";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    content: { minHeight: "calc(100vh - 50px)" },
    mainContent: {
        padding: spacing(8, 0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: spacing(1),
        backgroundColor: palette.warning.main
    },
    form: {
        width: "100%",
        marginTop: spacing(1)
    },
    btnsWrapper: { marginTop: spacing(3) }
}));

export class CDataFormData {
    public Login: string = "";
    public Password: string = "";
    public OTP: string = "";
}

export const _Login: React.FC<Glob.IRouteGlobaleProps> = props => {
    const classes = useStyles();

    const [FormData, setFormData] = useReducerOnChange<CDataFormData>(new CDataFormData());
    const [SecondPassword, setSecondPassword] = useState(false);

    const OnError = (error: Error) => {
        props.SetDialog({ Open: true, Title: "ERRORE", Content: Trad.Trad(error.message), Type: "error" });
    };

    const OnClickLogin = (dati: Dati.CRisAPIDatoSessioni) => {
        if (dati.Errore) {
            props.SetDialog({ Open: true, Title: "ERRORE", Content: Trad.Trad(dati.ErrTesto), Type: "error" });
            setSecondPassword(dati.ErrTesto == "ErroreLoginOTPCodice");
            setFormData({ Type: "OnChangeFromValue", Name: "OTP", Value: "" });
        } else {
            if (dati.Dato.SecondaPassword) {
                setSecondPassword(true);
                setFormData({ Type: "OnChangeFromValue", Name: "OTP", Value: "" });
            } else {
                let S = Glob.GetSessione();
                S = { ...S, ...dati.Dato };
                S.ID_Utente = dati.ID_Chiave;
                S.Nome = dati.Dato.Nome;

                props.SetSessione(S);
                window.location.href = "/dashboard";
                //this.props.history.push("/dashboard");
            }
        }
    };

    const OnClickRecoveryPassword = (dati: Dati.CRisAPIDatoSessioni) => {
        if (dati.Errore) {
            props.SetDialog({ Open: true, Title: "ERRORE", Content: Trad.Trad(dati.ErrTesto), Type: "error" });
        } else {
            props.SetDialog({ Open: true, Title: "Recupera password", Content: Trad.Trad("ControllareLaPropriaCasellaEmail"), Type: "success" });
        }
    };

    return (
        <_PageWrapper {...props}>
            <main>
                <Paper className={classes.content}>
                    <Container component="main" maxWidth="xs">
                        <div className={classes.mainContent}>
                            <Avatar className={classes.avatar}>
                                <LockOutlinedIcon />
                            </Avatar>
                            <Typography component="h2" variant="h5" color="primary">
                                {Trad.Trad("Login")}
                            </Typography>
                            <form className={classes.form} noValidate>
                                <TextField
                                    value={FormData.Login}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                    variant="outlined"
                                    margin="normal"
                                    id="Login"
                                    label={Trad.Trad("Username")}
                                    autoComplete="username"
                                    autoFocus
                                    required
                                    fullWidth
                                />
                                <TextField
                                    value={FormData.Password}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                    variant="outlined"
                                    margin="normal"
                                    label={Trad.Trad("Password")}
                                    type="password"
                                    id="Password"
                                    autoComplete="current-password"
                                    required
                                    fullWidth
                                />
                                {SecondPassword && (
                                    <TextField
                                        value={FormData.OTP}
                                        onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                        variant="outlined"
                                        margin="normal"
                                        label="OTP"
                                        type="password"
                                        id="OTP"
                                        autoComplete="off"
                                        required
                                        fullWidth
                                    />
                                )}
                                <Grid container justify="space-between" className={classes.btnsWrapper}>
                                    <Grid item xs={12} sm={4}>
                                        <_ButtonAPI
                                            Default
                                            Testo={Trad.Trad("Login")}
                                            URL="/api/Utenti/Login"
                                            ParamURLClasse={{ ...FormData, SecondaPassword: SecondPassword }}
                                            OnClick={OnClickLogin}
                                            OnErrore={OnError}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <_ButtonAPI
                                            Testo={Trad.Trad("Recupera password")}
                                            URL="/api/Utenti/RichiediRecuperaPassword"
                                            ParamURLClasse={{ login: FormData.Login }}
                                            OnClick={OnClickRecoveryPassword}
                                            OnErrore={OnError}
                                        />
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    </Container>
                </Paper>
            </main>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/Login.tsx